enum RelayStatus {
    Ok = 'OK',
    Ignored = 'IGNORED',
    Alarm = 'ALARM'
  }
  
  export default RelayStatus;